<script>
import Cover from './Cover.vue'
import Btn from './Btn.vue'
export default {
    components: {
        Cover,
        Btn
    },
    props: {
        width: {
            type: [String, Number],
            default: 349
        },
        title: String,
        simple: Boolean,
        btnText: {
            type: String,
            default: '确定'
        },
        hideClose: Boolean,
        showConfirm: Boolean,
        showBonusScene: Boolean,
        selfLogo: Boolean,
    },
    data() {
        return {
            clickTimes: 0,
            // showBonusScene: false,
        }
    },
    computed: {
        styleWidth() {
            return parseInt(this.width) + 'px'
        },
        style() {
            return {
                width: this.styleWidth,
                paddingTop: `${this.simple?48:28}px`
            }
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
        confirm() {
            this.$emit('confirm')
        },
        click() {
            this.clickTimes++
            if (this.clickTimes >= 5) {
                this.showBonusScene = true
            }
        }
    }
}
</script>

<template>
<Cover>
    <div class="About" v-if="!showBonusScene">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <p class="title">{{title}}</p>
                <img @click="$emit('close')" class="close" src="./assets/close_about.svg">
            </div>

            <img v-if="selfLogo" @click="click" class="logo" src="./assets/login_logo.svg">
            <!-- <CarouselInfo fixed /> -->
            <slot>
                <div class="holder"></div>
            </slot>
            <Btn class="Btn" v-if="showConfirm" @click="confirm">{{btnText}}</Btn>
        </el-card>
    </div>
    <transition name="slide-fade">
        <div v-if="showBonusScene" class='bonus_scene'>
            <div class="top">
                <img @click="$emit('close')" class="close" src="./assets/close_about.svg">
            </div>
            <div class="line"></div>
            <div class="developer">
                <p style="margin: 0 0 6px 23px;" class="text"><span>开发人员：</span>季检，李健东，杨春婷，白俊琦，李效腾，王竟韬</p>
                <p style="margin: 0 0 6px 23px;" class="text"><span />付磊，赵二天，唐佳伟，李庆阳，姜淑飞</p>
            </div>
        </div>
    </transition>
</Cover>
</template>

<style lang="scss" scoped>
.About {
    width: 500px;
    height: 300px;
    background: rgba(255, 255, 255, 1);
    border-radius: 12px;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;

    .title {
        font-size: 18px;
        font-weight: 400;
        color: #020202;
        line-height: 25px;
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .Btn {
        margin-left: 21px;
        margin-right: 21px;
        float: bottom;
        height: 48px;
        border-radius: 3px;
    }

    .line {
        width: 430px;
        height: 1px;
        background-color: #ebebeb;
        margin-bottom: 15px;
    }

    .logo {
        position: absolute;
        top: 110px;
        right: 22px;
        z-index: 20;
    }

    .close {
        position: absolute;
        padding: 10px;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }

    .box-card {
        height: auto;
        width: 500px;

        .el-card__header {
            height: 77px;

            .clearfix {
                margin-bottom: -10px;
            }
        }

        .el-carousel__container {
            height: 250px;

        }

        .el-carousel__indicator.is-active button {
            background-color: #00C1DE;
            height: 4px;
        }

        .el-carousel__indicator button {
            background-color: #A2A4A6;
            height: 4px;
        }
    }
}

.bonus_scene {
    width: 469px;
    height: 392px;
    background: rgba(255, 255, 255, 1);
    border-radius: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;

    .top {
        height: 302px;
        background-image: url('./assets/bonus_scene.png');

        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            padding: 10px;
            // margin-bottom: 10px;
            cursor: pointer;
        }
    }

    .line {
        width: 430px;
        height: 1px;
        background-color: #ebebeb;
        margin-bottom: 15px;
    }

    .developer {
        height: 90px;

        .text {
            >span {
                color: #646464;
                width: 70px;
                display: inline-block;
            }

            font-size:14px;
            font-weight:400;
            color:#646464;
            line-height:23px;
        }
    }
}

.slide-fade-enter-active {
    transition: all 1s ease;
}

.slide-fade-leave-active {
    transition: all 2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translate(-50%, 0);
    ;
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/AboutDialog.vue